import { Box, Button, Tile, Typography } from "@carrotfertility/carotene-core"
import React from "react"
import { FormattedMessage } from "react-intl"
import { useHistory } from "react-router-dom"
import { EligibleAirwallexKycStatus } from "#/lib/carrot-api/types/AirwallexKycStatus"

export function AirwallexKycHero({ status }: { status: EligibleAirwallexKycStatus }): JSX.Element {
  const history = useHistory()

  const inProgress = status === "InProgress"
  const completed = status === "Completed"

  const handleClick = () => {
    history.push("/awx/kyc")
  }

  return (
    <Tile
      component={Box}
      display="flex"
      border={(theme) => `2px solid ${theme.palette.background.paper}`}
      borderRadius={(theme) => theme.tokens.borderRadius.sm}
      color="info"
    >
      <Box
        display="flex"
        flexDirection="column"
        paddingBottom={(theme) => theme.spacing(theme.tokens.spacing.xs)}
        paddingTop={(theme) => theme.spacing(theme.tokens.spacing.xs)}
        gap={(theme) => theme.spacing(theme.tokens.spacing.md)}
      >
        <Typography variant="h4" color={(theme) => theme.palette.text.primary}>
          <FormattedMessage defaultMessage="Airwallex onboarding" />
        </Typography>
        <Typography variant="body1" color={(theme) => theme.palette.text.primary}>
          {completed ? (
            <FormattedMessage defaultMessage="Your onboarding information has been submitted. If you believe this is an error, please contact Carrot support." />
          ) : (
            <FormattedMessage defaultMessage="Please answer a few questions to complete Airwallex onboarding. This is a required step to set up your organization's Carrot Card® account." />
          )}
        </Typography>
        {!completed && (
          <Box>
            <Button onClick={handleClick} color="secondary" variant="contained" fullWidth={false}>
              {inProgress ? (
                <FormattedMessage defaultMessage="Continue Airwallex KYC" />
              ) : (
                <FormattedMessage defaultMessage="Complete onboarding" />
              )}
            </Button>
          </Box>
        )}
      </Box>
    </Tile>
  )
}
